import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import FancySelectRow from '../elements/FancySelectRow'

const options = {
    postUrl: '/api/postOptOutCGNAT',
    success: 'Your Carrier Grade NAT opt-out was successful and should take effect immediately.',
    dontScrollToNav: true
}
const state = {}

class CGNATOptOutForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    render () {
        const options = [
            'I have a device that requires a fixed IP address',
            'I need to connect to my location via remote access',
            'I require a static IP address for gaming',
            'My current IP address is blocked'
        ]

        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <p>You can opt-out of Carrier Grade-NAT by selecting a reason below.</p>
                <FancySelectRow
                    label='Reason to opt-out:'
                    name='requestReason'
                    value={this.props.values.requestReason}
                    errors={this.props.errors}
                    options={options}
                    handleChange={this.props.setDynamicValues}
                />
                {this.props.children}
                <div className='row mt-3'>
                    <div className='col-12 text-center text-md-right'>
                        <div className='d-inline-block my-md-2'>
                            <Button title='Opt-out' action={this.props.handleSubmit} />
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default FormHOC(CGNATOptOutForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/CGNATOptOutForm.js